/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 10:25:19
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 16:33:18
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentListPage/config.tsx
 */
import React from 'react';
import css from './css.module.less';
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('storePayment.paymentListPage.payment'),
  },
];

export const columns = (
  editAction,
  deleteAction,
  disableView,
  disableDelete,
  { getI18n },
) => [
  {
    title: getI18n('storePayment.paymentListPage.paymentGatewayName'),
    dataIndex: 'paymentGatewayName',
    key: 'paymentGatewayName',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 320,
  },
  {
    title: getI18n('storePayment.paymentListPage.paymentProvider'),
    dataIndex: 'gatewayProvider',
    key: 'gatewayProvider',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 256,
    render: (text) => text?.name,
  },
  {
    title: getI18n('storePayment.paymentListPage.availablePaymentMethod'),
    dataIndex: 'gatewayName',
    key: 'gatewayName',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 352,
    render: (text, record) => {
      return (
        <div>
          {record?.gatewayProvider?.supportedPaymentMethods?.map(
            (supportedPaymentMethod, i) =>
              supportedPaymentMethod.icons.map((icon, j) => (
                <img
                  style={{ height: 20, marginLeft: 8 }}
                  key={`${i}-${j}`}
                  src={icon.url}
                />
              )),
          )}
        </div>
      );
    },
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'action',
    key: 'action',
    default: true,
    optional: false,
    className: css.columnClass,
    width: 120,
    align: 'center',
    render: (text, record) => (
      <div className={css.action}>
        {disableView ? (
          '-'
        ) : (
          <span className={css.edit} onClick={() => editAction(record)}>
            {getI18n('general.edit')}
          </span>
        )}
        {disableDelete ? (
          '-'
        ) : (
          <span className={css.delete} onClick={() => deleteAction(record)}>
            {getI18n('general.delete')}
          </span>
        )}
      </div>
    ),
  },
];
